<template>
    <select @change="onChange()" ref="unitSelect">
        <option v-for="unit in currentPlacingUnits" :value="unit.unit.id" :key="unit.unit.id"> {{unit.unit.name}} ({{unit.count}})</option>
    </select>
</template>

<script>
export default {
    data(){
        return{
            currentPlacingUnits: this.game.currentPlacingUnits,
        }
    },
    methods: {
        updateUnitList(value){
            this.currentPlacingUnits = [...value];
            this.onChange();
        },
        updatePlacingUnit(value){
            if(value){
                this.$refs.unitSelect.value = value;
            }
        },
        onChange(){
            this.game.setPlacingUnit(this.$refs.unitSelect.value);
        },
    },
    props: {
        units: {
            type: Array,
            required: true
        }
    },
    inject: ["game"],
    created() {
        this.game.updaters.unitSelector = this.updateUnitList;
        this.game.updaters.placingUnit = this.updatePlacingUnit;
    },
    mounted() {
        const placingUnitBackup = this.game.placingUnit;
        this.game.updateUnitSelector();
        this.game.setPlacingUnit(placingUnitBackup);
        try{
            const placingUnit = JSON.parse(localStorage.getItem('prepStageBackup')).placingUnit;
            this.updatePlacingUnit(placingUnit);
        }
        catch{
            // Ignore
        }
    }
}
</script>

<style>

</style>